/** Shared brand header for the auth screens: the Chariot wordmark plus a
 * page-specific tagline. */
export function AuthBrandHeader({ tagline }: { tagline: string }) {
  return (
    <div className="mb-8 text-center">
      <h1 className="mb-1 font-serif text-3xl font-semibold tracking-tight text-foreground">
        Chariot
      </h1>
      <p className="text-sm text-muted-foreground">{tagline}</p>
    </div>
  );
}
